export default __webpack_public_path__ + "66de870c95578ef293a3c8fedffa716e.svg";